import Rete from 'rete';
import trackNodeHistory from '../utils/history/trackNodeHistory';

import Group from './Group';

class GroupComponent extends Rete.Component {
  constructor(emitter) {
    super('Group');
    this.render = 'vue';
    this.data.component = Group;
    this.data.props = {};
    this.emitter = emitter;
  }
  builder = node => {
    trackNodeHistory(this, node, this.emitter);
  };
}

export default GroupComponent;
